__turbopack_context__.v({
  "body": "index-module-scss-module__HVtPQa__body",
  "filler": "index-module-scss-module__HVtPQa__filler",
  "link": "index-module-scss-module__HVtPQa__link",
  "root": "index-module-scss-module__HVtPQa__root",
});
